var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkItem1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 24.0001H8C7.26363 24.0001 6.66667 24.597 6.66667 25.3334C6.66667 26.0698 7.26363 26.6667 8 26.6667H28V29.3334H8C5.79087 29.3334 4 27.5426 4 25.3334V5.33341C4 3.86065 5.19391 2.66675 6.66667 2.66675H28V24.0001ZM6.66667 21.4001C6.88208 21.3563 7.10503 21.3334 7.33333 21.3334H25.3333V5.33341H6.66667V21.4001ZM21.3333 12.0001H10.6667V9.33341H21.3333V12.0001Z",
    fill: "#26539C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkItem1);
export default __webpack_public_path__ + "static/media/icon_link_item1.54bee4ef6b00296cd66217b0bea884dc.svg";
export { ForwardRef as ReactComponent };